import { useState, useEffect } from "react";
import Config from "../../../Config";


function Support(props)
{

    return (
        <div className="view_content">
              <h1>Wsparcie techniczne </h1>

              <div>
                    <p>
                    Dziękujemy za korzystanie z naszego systemu "eLizak"! Jeśli napotkasz jakiekolwiek problemy 
                    lub brakuje Ci jakiejś funkcji, daj nam znać - chętnie pomożemy! 
                    <br/><br/>Skontaktuj się z nami, a postaramy się znaleźć najlepsze rozwiązanie dla Ciebie i innych rodziców.
                    </p>
              </div>

              <div>
                E-mail: <b>kontakt@elizak.edu.pl</b>
              </div>

        </div>
    )

}

export default Support;